import * as React from 'react'
import { MessageBarType } from "@fluentui/react";
import { MessageBarComponent } from './MessageBarComponent';
import { IResponseApi } from '../../interfaces/base/IResponse';


interface IMessageBarResponse {
  objetoResponse: IResponseApi;
  close?: boolean;
}

export const MessageBarResponse = (props: IMessageBarResponse) => {
  return (
    <>
      {props.objetoResponse?.codigo === 200 && (
        <MessageBarComponent type={MessageBarType.success}
          text={props.objetoResponse.mensaje} intro="Correcto"
          showIcon={props.close}
        />
      )}
      {props.objetoResponse?.codigo === 400 && (
        <MessageBarComponent type={MessageBarType.warning}
          text={props.objetoResponse?.mensaje} intro="Advertencia"
          showIcon={props.close}
        />
      )}
      {props.objetoResponse?.codigo === 500 && (
        <MessageBarComponent type={MessageBarType.error}
          text={props.objetoResponse?.mensaje} intro="Error"
          showIcon={props.close}
        />
      )}
      {props.objetoResponse?.codigo === 0 && (
        <MessageBarComponent type={MessageBarType.info}
          text={props.objetoResponse?.mensaje} intro="Info"
          showIcon={props.close}
        />
      )}
    </>
  );
};